// Feedback response values
export const FEEDBACK_RESPONSE = {
  YES: 'Yes',
  NO: 'No',
  NA: 'N/A',
} as const;

export type FeedbackResponse =
  (typeof FEEDBACK_RESPONSE)[keyof typeof FEEDBACK_RESPONSE];
